<template>
  <div class="tab-steam">
    <SteamKeys
      :contentOwnership="contentOwnership"
      :uploading="keysUploading"
      @uploadGameKeys="uploadGameKeys"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import SteamKeys from '../components/content-fields/SteamKeys';

@Component({
  components: {
    ContentBlock,
    SteamKeys,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
})
export default class TabSteamRoute extends Vue {
  keysUploading = false;

  async uploadGameKeys (file) {
    this.keysUploading = true;
    try {
      await this.$store.dispatch('uploadGameKeys', {
        contentOwnership: { id: this.contentOwnership.id },
        file,
      });
    } finally {
      this.keysUploading = false;
    }
  }
}
</script>
